import React, { useEffect, useState } from "react";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import defaultUserProfile from "../../assets/defaultUserProfile.jpeg";
import "../post/comment.css";

const CommentSection = ({ comments, postId, token, user, onCommentAdded }) => {
  const [open, setOpen] = useState(false);
  const [commentType, setCommentType] = useState("View");
  const [formData, setFormData] = useState({ comment: "" });
  const [errors, setErrors] = useState({});
  const [commentList, setCommentList] = useState(comments);
  const [menuOpenId, setMenuOpenId] = useState(null);

  const toggleComments = () => {
    setOpen(!open);
    setCommentType((prev) => (prev === "View" ? "Hide" : "View"));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, comment: e.target.value });
  };

  // useEffect(()=>{
  //   commentList();
  // },[commentList]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    const response = await fetch("https://dashboard.tiktaka.com/api/comment", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ comment: formData.comment, post_id: postId }),
    });
    const data = await response.json();
    if (response.ok) {
      setFormData({ comment: "" });
      console.log('data');
      console.log(data.data);
            
      const newComment = {
          id: data.data.id,
          comment: data.data.comment,
          created_at: data.data.created_at,
          user: {
            id: user.id,
            name: user.name,
            avatar: user.avatar,
          },
        };

        setCommentList([newComment, ...commentList]);
      onCommentAdded();
    } else if (response.status === 422) {
      setErrors(data.errors);
    }
  };

  const handleDelete = async (commentId) => {
    try {
      const response = await fetch(
        `https://dashboard.tiktaka.com/api/comment/delete/${commentId}`,
        { method: "DELETE", headers: { Authorization: `Bearer ${token}`, Accept: "application/json" } }
      );

      if (response.ok) {
        setCommentList(commentList.filter((c) => c.id !== commentId));
        setMenuOpenId(null);
      }
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  return (
    <div className="comment-section">
      <div className="noOfComments" onClick={toggleComments}>
        {commentList.length > 0
          ? `${commentType} All ${commentList.length} Comments`
          : "No Comments"}
      </div>

      {open && (
        <div className="commentsList">
          {commentList.map((comment) => (
            <div key={comment.id} className="commentItem">
              <img
                className="commentUserImg"
                src={comment.user.avatar ? `https://dashboard.tiktaka.com/${comment.user.avatar}` : defaultUserProfile}
                alt="profile"
              />
              <div className="commentBody">
                <div>
                  <span className="commentUsername">{comment.user.name}</span>{" "}
                  <span className="commentText">{comment.comment}</span>
                </div>
                <div className="commentTime">
                  {new Date(comment.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                </div>
              </div>

              {/* ثلاث نقاط وشاشة pop-up */}
              {user && user.id === comment.user.id && (
                <div className="menuWrapper">
                  <span
                    className="menuDots"
                    onClick={() => setMenuOpenId(menuOpenId === comment.id ? null : comment.id)}
                  >
                    ⋯
                  </span>

                  {menuOpenId === comment.id && (
                    <div className="menuDropdown">
                      <button onClick={() => handleDelete(comment.id)}>Delete</button>
                      <button onClick={() => setMenuOpenId(null)}>Cancel</button>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "20px" }}>
          <input
            type="text"
            className="addComment"
            placeholder="Add a comment here ..."
            value={formData.comment}
            onChange={handleChange}
            style={{ flex: 1 }}
          />
          <button type="submit" className="sharePostBtn">
            <SendOutlinedIcon sx={{ fontSize: "20px" }} />
          </button>
        </div>

        {errors.comment && <div style={{ color: "red", fontSize: "12px" }}>{errors.comment[0]}</div>}
      </form>
    </div>
  );
};

export default CommentSection;
